import { render, staticRenderFns } from "./DeckComponent.vue?vue&type=template&id=67f1036c&scoped=true"
import script from "./DeckComponent.vue?vue&type=script&lang=js"
export * from "./DeckComponent.vue?vue&type=script&lang=js"
import style0 from "./DeckComponent.vue?vue&type=style&index=0&id=67f1036c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1036c",
  null
  
)

export default component.exports